import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const contentGateInputs = [
  {
    name: "logoSrc",
    type: "file",
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F9d1d2ffe26704533a8ad5fbf1abac751",
    required: true,
  },
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Sorry,this content is restricted",
  },
  {
    name: "isIPRecogintionEnabled",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "restrictionLabel",
    type: "string",
    required: true,
    defaultValue: "Redirect to a page",
    showIf: 'options.get("isIPRecogintionEnabled") === true',
  },
  {
    name: "mapCode",
    type: "string",
    required: true,
    showIf: 'options.get("isIPRecogintionEnabled") === true',
    defaultValue: "ploom-countries",
  },
  {
    name: "whyContentRestricted",
    type: "object",
    required: true,
    subFields: [
      {
        name: "label",
        type: "string",
        required: true,
      },
      {
        name: "link",
        type: "url",
        required: true,
      },
    ],
    defaultValue: {
      label: "Why is this content restricted?",
      link: "#",
    },
  },
  {
    name: "restrictions",
    type: "list",
    required: true,
    defaultValue: [
      {
        type: "DEVICE_REGISTRATION",
        label: "Register your device",
        link: "#",
      },
    ],
    showIf: 'options.get("isIPRecogintionEnabled") === false',
    subFields: [
      {
        name: "type",
        type: "string",
        enum: ["DEVICE_REGISTRATION", "LOGGED_IN", "AGE_VERIFIED", "PURPOSE"],
      },
      {
        name: "label",
        type: "string",
        required: true,
      },
      {
        name: "link",
        type: "url",
        required: true,
      },
      {
        name: "purposeId",
        type: "string",
      },
    ],
  },
] as const satisfies Inputs;

export const ContentGateComponent: RegisteredComponent = {
  name: "Content Gate",
  component: dynamic(
    async () =>
      withValidation(
        contentGateInputs,
        (await import("./ContentGate")).ContentGate,
        "ContentGate"
      ),
    { ssr: false }
  ),
  inputs: contentGateInputs,
};
